import { defineComponent as _defineComponent } from 'vue'
import DatepickerSection from '@/activities/modals/createEditActivity/components/DatepickerSection.vue';
import IconSelectSection, { IconType } from '@/activities/modals/createEditActivity/components/IconSelectSection.vue';
import NoteWorkInstructionSection from '@/activities/modals/createEditActivity/components/NoteWorkInstructionsSection.vue';

interface Props {
  availableIconTypes: IconType[] | null;
  selectedIconTypes: IconType[];
  selectedDates?: Date[];
  startTime?: string | null;
  workingTime?: string | null;
  setupTime?: string | null;
  drivingTime?: string | null;
  pauseTime?: string | null;
  userComments?: string[];
  regionCodes: string[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FirstStep',
  props: {
    availableIconTypes: { default: null },
    selectedIconTypes: null,
    selectedDates: null,
    startTime: null,
    workingTime: null,
    setupTime: null,
    drivingTime: null,
    pauseTime: null,
    userComments: null,
    regionCodes: null
  },
  emits: ["setSelectedDate", "setStartTime", "setWorkingTime", "setDrivingTime", "setSetupTime", "setPauseTime", "setIconType", "setComment"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'setSelectedDate', date: Date): Date;
  (e: 'setStartTime', time: string): string;
  (e: 'setWorkingTime', time: string): string;
  (e: 'setDrivingTime', time: string): string;
  (e: 'setSetupTime', time: string): string;
  (e: 'setPauseTime', time: string): string;
  (e: 'setIconType', iconType: IconType): IconType;
  (e: 'setComment', comment: string): string;
}), expose: any, slots: any, attrs: any }) {





function setSelectedDate(date: Date) {
  emit('setSelectedDate', date);
}

function setStartTime(time: string): void {
  emit('setStartTime', time);
}

function setWorkingTime(time: string): void {
  emit('setWorkingTime', time);
}

function setDrivingTime(time: string): void {
  emit('setDrivingTime', time);
}

function setSetupTime(time: string): void {
  emit('setSetupTime', time);
}

function setPauseTime(time: string): void {
  emit('setPauseTime', time);
}

function setIconType(iconType: IconType): void {
  emit('setIconType', iconType);
}

function setComment(comment: string): void {
  emit('setComment', comment);
}

return { __sfc: true,emit, setSelectedDate, setStartTime, setWorkingTime, setDrivingTime, setSetupTime, setPauseTime, setIconType, setComment, DatepickerSection, IconSelectSection, IconType, NoteWorkInstructionSection }
}

})